import { State } from '../State';
import * as Tutorial from '../tutorial';
import {
  PuzzleRewards,
  puzzleCoinsFirstReward,
  puzzleCoinsRewards,
} from './puzzlecoins.ruleset';

/**
 * Get the B-Point reward for completing a puzzle.
 *
 * @param state Current player state.
 * @param stars Stars earned for the completed puzzle.
 * @returns The puzzle reward (level 1 always returns the fixed first reward), or undefined when the star count is invalid.
 */
export function puzzleCoinsGetReward(
  state: State,
  stars: number,
): PuzzleRewards | undefined {
  // First puzzle has a fixed reward
  if (state.match2.level === 1) {
    return puzzleCoinsFirstReward;
  }

  // Check if stars are valid - should be 1, 2 or 3
  if (stars < 1 || stars > 3) return undefined;

  // Return the standard reward for the star rating.
  return puzzleReward(stars);
}

/**
 * Get the reward for completing a puzzle based on the number of stars.
 */
function puzzleReward(stars: number): PuzzleRewards {
  return puzzleCoinsRewards[Math.floor(stars)]!;
}

/**
 * Check if the user is playing the tutorial for this feature.
 * @returns
 */
export function puzzleCoinsIsPlayingTutorial(state: State): boolean {
  const tutorialComplete = Tutorial.getters.isTutorialStepComplete(
    state,
    'puzzleCoinsCare',
  );

  // Only replace the launch sequence if the tutorial is not complete
  return !tutorialComplete;
}

/**
 * Check if the user is playing the tutorial for this feature, in deterministic version.
 * @returns
 */
export function puzzleCoinsIsPlayingTutorialDeterministic(
  state: State,
): boolean {
  return puzzleCoinsIsPlayingTutorial(state);
}
